import {
  JournalExportEntity,
  JournalExportParamsEntity,
} from "../../entities/JournalExportEntity";
import { JournalExportRepository } from "../../repositories/JournalExportRepository";

export class DownloadJournalExportExcelUseCase {
  constructor(private repository: JournalExportRepository) {}

  async execute(
    params: JournalExportParamsEntity = {},
  ): Promise<JournalExportEntity> {
    const from = params.fromDate?.trim() || "";
    const to = params.toDate?.trim() || "";

    if ((from && !to) || (!from && to)) {
      throw new Error("Please select both From date and To date.");
    }
    if (from && to && from > to) {
      throw new Error("From date must be before or equal to To date.");
    }

    return await this.repository.downloadJournalExportExcel({
      fromDate: from || undefined,
      toDate: to || undefined,
    });
  }
}
